import React, { memo } from "react";

const LetterCell = (props) => {
  return (
    <div
      style={{
        borderTop: props.original.letra !== "" ? "2px solid white" : "none",
        borderTopRightRadius:
          props.original.letra !== "" ? "calc(.25rem - 1px)" : "0",
        borderTopLeftRadius:
          props.original.letra !== "" ? "calc(.25rem - 1px)" : "0",
        borderBottomRightRadius:
          props.original.letra_len > 1 && props.original.letra !== ""
            ? "0"
            : "calc(.25rem - 1px)",
        borderBottomLeftRadius:
          props.original.letra_len > 1 && props.original.letra !== ""
            ? "0"
            : "calc(.25rem - 1px)",
      }}
    >
      {props.original.letra !== "" ? props.original.letra : " "}
    </div>
  );
};

export default memo(LetterCell);
